import { PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { Modal } from '@/components/Modal'

interface ConfirmationModalProps {
  isOpen: boolean
  onSuccess?: () => void
  successLabel?: ReactNode
  onCancel?: () => void
  cancelLabel?: string
  header?: {
    icon: ReactNode
    title: string
  }
}

export const ConfirmationModal = ({
  isOpen,
  onSuccess,
  successLabel,
  onCancel,
  cancelLabel,
  children,
  header
}: PropsWithChildren<ConfirmationModalProps>) => {
  const { t } = useTranslation()

  const actions = [
    ...(onSuccess ? [{ label: successLabel ?? t('button.yes'), onClick: onSuccess, variant: 'primary' as const }] : []),
    ...(onCancel ? [{ label: cancelLabel ?? t('button.no'), onClick: onCancel, variant: 'outline' as const }] : [])
  ]

  return (
    <Modal isOpen={isOpen} actions={actions} header={header}>
      {children}
    </Modal>
  )
}
